import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import axios from 'axios';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
 //TODO JAVIER VER SI BORRAR ESTE COMPONENTE O VER SI PUEDO APROVECHAR




}
